<template>
  <!-- 平台总览页面 -->
  <div>
    <div class="bg-content fixed-header">
      <el-form label-width="100px" v-if="!this.$partB()">
        <!-- 第一行 -->
        <el-row :gutter="12">
          <el-col :span="8">
            <el-form-item label="案件批次号">
              <batch-selector v-model="searchQuery.batchNo" :batchNo="batchNoDefault" :testing="true"></batch-selector>
            </el-form-item>
          </el-col>
         <el-col :span="8">
            <el-form-item label="导入时间">
              <el-date-picker style="width: 100%;"
                v-model="searchQuery.importStartTime"
                type="datetime"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择日期时间">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="至">
              <el-date-picker style="width: 100%;"
                v-model="searchQuery.importEndTime"
                type="datetime"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择日期时间">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="12">
          <el-col :span="8">
            <el-form-item label="策略组">
              <el-select v-model="searchQuery.groupIds" filterable multiple collapse-tags placeholder="请选择" style="width: 100%;">
                <el-option
                  v-for="item in groupList"
                  :key="item.id"
                  :label="item.groupName"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 按钮操作 -->
          <div class="padding15-tb text right">
            <el-button type="primary" @click="search" size="mini"> <i class="fa fa-search"></i> 搜索</el-button>
            <el-button size="mini" @click="resetBtn">重置</el-button>
          </div>
        </el-row>
      </el-form>
       <el-form label-width="100px" v-if="this.$partB()">
        <!-- 第一行 -->
        <el-row :gutter="12">
          <el-col :span="8">
            <el-form-item label="案件批次号">
              <batch-selector v-model="searchQuery.batchNo" :batchNo="batchNoDefault" :testing="true"></batch-selector>
            </el-form-item>
          </el-col>
         <el-col :span="8">
            <el-form-item label="导入时间">
              <el-date-picker style="width: 100%;"
                v-model="searchQuery.importStartTime"
                type="datetime"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择日期时间">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="至">
              <el-date-picker style="width: 100%;"
                v-model="searchQuery.importEndTime"
                type="datetime"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择日期时间">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <!--  第二行 -->
        <el-row :gutter="12">
          <el-col :span="8">
            <el-form-item label="公司名称">
              <el-select v-model="searchQuery.companyName" filterable multiple collapse-tags placeholder="请选择" style="width: 100%;" @change="companyChange">
                <el-option
                  v-for="item in companyNameList"
                  :key="item.id"
                  :label="item.companyName"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="策略组">
              <el-select v-model="searchQuery.groupIds" filterable multiple collapse-tags placeholder="请选择" style="width: 100%;">
                <el-option
                  v-for="item in groupList"
                  :key="item.id"
                  :label="item.companyName + '( '+item.groupName + ')'"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 按钮操作 -->
          <div class="padding15-tb text right">
            <el-button type="primary" @click="search" size="mini"> <i class="fa fa-search"></i> 搜索</el-button>
            <el-button size="mini" @click="resetBtn">重置</el-button>
          </div>
        </el-row>
      </el-form>
    </div>
    <div class="page">
      <!-- 头部 -->
      <div class="index-header">
        <el-row :gutter="24">
          <el-col :span="6">
            <el-card shadow="never">
              <div class="card-content">
                <p class="text lighter">案件总数</p>
                <h3><strong>{{total}}</strong></h3>
                <div class="chart-content">
                  <div class="chart-content__fixed">
                    <p class="text light" v-if="this.perDay.toString().substring(0,1) === '-'">
                      日同比 {{perDay.toString().substring(1,10)}}% <i class="el-icon-caret-bottom"></i>
                    </p>
                    <p class="text light" v-else>
                      日同比 {{perDay}}% <i class="el-icon-caret-top"></i>
                    </p>
                  </div>
                </div>
              </div>
              <div class="card-footer">
                <p class="text">当月日均案件量{{daily}}</p>
              </div>
            </el-card>
          </el-col>
          <el-col :span="6">
            <el-card shadow="never">
              <div class="card-content">
                <p class="text lighter">作业中案件数</p>
                <h3><strong>{{colling}}</strong></h3>
                <div class="chart-content">
                  <div class="chart-content__fixed" style="height: 46px;">
                    <ve-line :data="headerChartData1" :settings="{ area: true }" height="46px" :extend="chartOpts1"></ve-line>
                  </div>
                </div>
              </div>
              <div class="card-footer">
                <p class="text">平均作业天数 {{collingMean}}</p>
              </div>
            </el-card>
          </el-col>
          <el-col :span="6">
            <el-card shadow="never">
              <div class="card-content">
                <p class="text lighter">当日待人工处理案件总数</p>
                <h3><strong>{{manProcessing}}</strong></h3>
                <div class="chart-content">
                  <div class="chart-content__fixed" style="height: 46px;">
                    <ve-histogram :data="headerChartData2" height="46px" :extend="chartOpts2"></ve-histogram>
                  </div>
                </div>
              </div>
              <div class="card-footer">
                <p class="text">日均待人工处理案件数 {{manProcessingMean}}</p>
              </div>
            </el-card>
          </el-col>
          <el-col :span="6">
            <el-card shadow="never">
              <div class="card-content">
                <span class="text lighter" v-if="this.$collectible()">已还款案件数</span>
                <span class="text lighter" v-else>已转化案件数</span>
                <h3><strong>{{confirmedPayment}}</strong></h3>
                <div class="chart-content">
                  <div class="chart-content__fixed">
                    <span v-if="this.$collectible()">核实还款占总作业中案件比例</span>
                    <span v-else>已转化案件数占总作业中案件比例</span>
                    <el-progress :percentage=this.scale color="#13c2c2"></el-progress>
                  </div>
                </div>
              </div>
              <div class="card-footer">
                <br/>
              </div>
            </el-card>
          </el-col>
        </el-row>
      </div>

      <div class="index-section m-t-24">
        <el-row :gutter="24">
          <el-col :span="12">
            <div class="panel">
              <div class="panel-header">
                <i class="el-icon-tickets">&nbsp;每日发送量</i>
                <div class="fr send-options">
                  <el-radio-group v-model="radio" @change="getSendAndResponseCount">
                    <el-radio-button label="day">日</el-radio-button>
                      <el-radio-button label="week">周</el-radio-button>
                      <el-radio-button label="month">月</el-radio-button>
                  </el-radio-group>
                </div>
              </div>
              <div class="panel-content">
                <ve-line :data="chartData" width="100%"></ve-line>
              </div>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="panel">
              <div class="panel-header">
                <i class="el-icon-tickets">&nbsp;每日回收</i>
                <div class="fr send-options">
                  <el-radio-group v-model="radioRecycling" @change="getRecyclingchartData">
                    <el-radio-button label="day">日</el-radio-button>
                      <el-radio-button label="week">周</el-radio-button>
                      <el-radio-button label="month">月</el-radio-button>
                  </el-radio-group>
                </div>
              </div>
              <div class="panel-content">
                <ve-histogram :data="RecyclingchartData" :settings="RecyclingSetting"></ve-histogram>
                <!-- <ve-line :data="chartData" width="100%"></ve-line> -->
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="index-section m-t-24">
        <div class="panel">
          <div class="panel-header">
            <i class="el-icon-tickets">&nbsp;批次总览</i>
            <el-button type="text" class="el-icon-refresh" style="float: right;" @click="batchInfoOfPandect" round></el-button>
          </div>
          <div class="panel-content">
            <el-table
              v-loading="batchInfoOfPandectLoading"
              ref="singleTable"
              :data="tableData"
              size="small"
              @row-click="toCaseList"
              highlight-current-row
              style="width: 100%">
              <el-table-column
                property="batchNo"
                fixed
                width="180px"
                align="center"
                label="批次号">
              </el-table-column>
              <el-table-column
                property="groupName"
                fixed
                width="130px"
                align="center"
                label="策略组">
                <template slot-scope="scope">
                  <span>{{scope.row.groupName + "(" + scope.row.groupId + ")"}} </span>
                </template>
              </el-table-column>
              <el-table-column
                property="caseCount"
                width="70px"
                align="center"
                label="案件总数">
              </el-table-column>
               <el-table-column
                property="collingCount"
                width="100px"
                align="center"
                label="作业中案件数">
              </el-table-column>
              <el-table-column
                property="colledCountStr"
                align="center"
                label="作业完成案件数">
              </el-table-column>
              <el-table-column
                align="center"
                :label="this.$collectible() ? '核实还款' : '转化案件量'">
                <template slot-scope="scope">
                  <span>{{scope.row.confirmedPaymentCountStr}}</span>
                </template>
              </el-table-column>
              <el-table-column
                property="contactCount"
                align="center"
                width="70px"
                label="联系人数">
              </el-table-column>
              <el-table-column
                property="sendCount"
                align="center"
                width="70px"
                label="已发送">
              </el-table-column>
              <el-table-column
                property="noSendCount"
                align="center"
                width="70px"
                label="未发送">
              </el-table-column>
              <el-table-column
                property="responseCountStr"
                align="center"
                label="回复数">
              </el-table-column>
              <el-table-column
                property="answerCountStr"
                align="center"
                label="接听数">
              </el-table-column>
              <el-table-column
                property="responseAndAnsweredCountStr"
                align="center"
                min-width="100px"
                label="接听+回复数">
              </el-table-column>
              <el-table-column
                align="center"
                :label="this.$collectible() ? '有还款意向' : '明确意愿'">
                <template slot-scope="scope">
                  <span>{{scope.row.willingPayCountStr}}</span>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                :label="this.$collectible() ? '待人工处理' : '有意愿未明确'">
                <template slot-scope="scope">
                  <span>{{scope.row.manProcessingCountStr}}</span>
                </template>
              </el-table-column>
              <el-table-column
                property="effectiveCountStr"
                align="center"
                label="有效联系">
              </el-table-column>
              <el-table-column
                property="msgFailedCountStr"
                align="center"
                label="短信失败数">
              </el-table-column>
              <el-table-column
                property="ivrFailedCountStr"
                align="center"
                label="语音失败数">
              </el-table-column>
              <el-table-column
                property="msgAndIvrFailedCountStr"
                align="center"
                min-width="120px"
                label="短信+语音失败数">
              </el-table-column>
              <el-table-column
                property="importTime"
                align="center"
                label="导入时间">
              </el-table-column>
              <el-table-column
                label="批次报告"
                align="center">
                <template slot-scope="scope">
                  <i class="fa fa-list" v-on:click="tobatchReport(scope.row)" style="cursor:pointer"></i>
                </template>
              </el-table-column>
            </el-table>
            <div class="text center margin15-tb">
              <el-pagination
                background
                layout="prev, pager, next, sizes, total"
                :page-sizes="[10, 20, 50, 100]"
                :total="batchOverview.totalRecords"
                :page-size="batchOverview.limit"
                :current-page="batchOverview.page"
                @current-change="currentChange"
                @size-change="sizeChange">
              </el-pagination>
            </div>
          </div>
        </div>
      </div>
      <div class="index-section m-t-24">
        <div class="panel">
          <div class="panel-header">
            <i class="el-icon-tickets">&nbsp;待人工处理</i>
            <el-button type="text" class="el-icon-refresh" style="float: right;" @click="getManProcessList" round></el-button>
          </div>
          <div class="panel-content">
            <el-table
              v-loading="manProcessLoading"
              ref="singleTable"
              :data="manProcessTbody"
              size="small"
              @row-click="toDetail"
              highlight-current-row
              style="width: 100%">
              <el-table-column
                property="batchId"
                fixed
                label="批次号"
                width="180px">
              </el-table-column>
              <el-table-column
                property="aCaseId"
                label="案件号"
                width="180px">
              </el-table-column>
              <el-table-column
                property="customername"
                label="客户姓名"
                width="80px">
              </el-table-column>
              <el-table-column
                property="content"
                label="回复内容"
                width="430px">
              </el-table-column>
              <el-table-column
                property="time"
                label="时间"
                width="150px">
              </el-table-column>
              <el-table-column
                property="relationship"
                label="对象">
              </el-table-column>
              <el-table-column
                property="caseStatus"
                label="案件状态">
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <div class="index-section m-t-24">
        <div class="panel">
          <div class="panel-header">
            <i class="el-icon-tickets">&nbsp;最新回复列表</i>
            <el-button type="text" class="el-icon-refresh" style="float: right;" @click="getAllResponseList" round></el-button>
          </div>
          <div class="panel-content">
            <el-table
              v-loading="allResponseLoading"
              ref="singleTable"
              :data="allResponseList"
              size="small"
              @row-click="toDetail"
              highlight-current-row
              style="width: 100%">
              <el-table-column
                property="aCaseId"
                fixed
                width="160px"
                align="center"
                label="进件号">
              </el-table-column>
              <el-table-column
                property="loanInstitutions"
                align="center"
                label="贷款机构">
              </el-table-column>
              <el-table-column
                property="name"
                align="center"
                label="姓名">
              </el-table-column>
              <el-table-column
                property="importTime"
                align="center"
                label="导入日期">
              </el-table-column>
              <el-table-column
                property="responseTime"
                align="center"
                label="回复时间">
              </el-table-column>

              <el-table-column
                property="content"
                align="center"
                label="回复内容">
              </el-table-column>
              <el-table-column
                property="replyTime"
                align="center"
                label="回复轮次">
              </el-table-column>

              <el-table-column
                property="contactStatus"
                align="center"
                label="本人联系状态">
              </el-table-column>

              <el-table-column
                property="urgeStatus"
                align="center"
                label="作业状态">
              </el-table-column>

            </el-table>
            <div class="text center margin15-tb">
              <el-pagination
                background
                layout="prev, pager, next, sizes, total"
                :page-sizes="[10, 20, 50]"
                :total="allResponseOverview.totalRecords"
                :page-size="allResponseOverview.limit"
                :current-page="allResponseOverview.page"
                @current-change="getAllResponseCurrentChange"
                @size-change="getAllResponseSizeChange">
              </el-pagination>
            </div>
          </div>
        </div>
      </div>
      <div class="index-section m-t-24" v-if="this.$hasPerm('XQ014')">
        <div class="panel">
          <div class="panel-header">
            <i class="el-icon-time">&nbsp;最新回复</i>
            <el-button type="text" class="el-icon-refresh" style="float: right;" @click="getNewResponseInfo" round></el-button>
          </div>
          <div class="panel-content" v-loading="newResponseLoading">
            <time-line :list="messages"></time-line>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>
<script>
import { Base64 } from 'js-base64';
import moment from 'moment';
import VeLine from 'v-charts/lib/line.common';
import VeRing from 'v-charts/lib/ring.common';
import VeHistogram from 'v-charts/lib/histogram.common';
import TimeLine from '../../../components/TimeLine';
import BatchSelector from '../../../components/bussiness-select/BatchSelector';

export default {
  inject: ['reload'],
  data() {
    this.chartSettings = {
      radius: [10, 100],
      offsetY: 250,
      legendLimit: 6
    };
    this.RecyclingSetting = {
      showLine: ['回收率'],
      axisSite: { right: ['回收率'] },
      yAxisType: ['', 'percent']
    };
    // 案件状态分布 监控事件
    // const self = this;
    // this.chartEvents = {
    //   click(e) {
    //     const CaseStatusBanchList = self.chartData1.rows;
    //     for (let index = 0; index < CaseStatusBanchList.length; index++) {
    //       const element = CaseStatusBanchList[index];
    //       if (element.caseStatusName === e.name) {
    //         self.operateCache([], [element.caseStatusCode]);
    //         self.$router.push({ path: '/main/case/caseList' });
    //       }
    //     }
    //   }
    // };
    return {
      companyNameList: [],
      groupList: [],
      searchQuery: {
        companyName: [],
        batchNo: [],
        importStartTime: '',
        importEndTime: '',
        groupIds: []
      },
      total: 0,
      colling: 0,
      manProcessing: 0,
      confirmedPayment: 0,
      daily: 0,
      perDay: 0,
      collingMean: 0,
      manProcessingMean: 0,
      scale: 0,
      headerChartData1: {
        columns: ['日期', '作业案件数'],
        rows: []
      },
      headerChartData2: {
        columns: ['日期', '待人工处理案件数'],
        rows: []
      },
      chartOpts1: {
        legend: {
          show: false
        },
        grid: {
          left: -40,
          right: -40
        },
        xAxis: {
          show: false,
          boundaryGap: false
        },
        yAxis: {
          show: false,
          min: 1000,
          max: 150000
        },
        color: ['#975fe4']
      },
      chartOpts2: {
        legend: {
          show: false
        },
        grid: {
          left: 0,
          right: 0
        },
        xAxis: {
          show: false,
          boundaryGap: false
        },
        yAxis: {
          show: false,
          min: 0,
          max: 500
        },
        color: ['#1890ff']
      },
      chartData: {
        columns: ['日期', '短信发送量', '语音发送量', '短信回复量'],
        rows: []
      },
      RecyclingchartData: {
        columns: ['日期', '案件导入量', '回收率'],
        rows: []
      },
      // chartData1: {
      //   columns: ['caseStatusName', 'total', 'caseStatusCode'],
      //   rows: []
      // },
      tableData: [],
      manProcessTbody: [],
      radio: 'day',
      messages: [],
      batchOverview: {
        totalRecords: 0,
        limit: 10,
        page: 1
      },
      batchNoDefault: [],
      radioRecycling: 'day',
      allResponseList: [],
      allResponseOverview: {
        totalRecords: 0,
        limit: 10,
        page: 1
      },
      newResponseLoading: false,
      allResponseLoading: false,
      manProcessLoading: false,
      batchInfoOfPandectLoading: false
    };
  },
  // 进入页面调用此方法
  mounted() {
    this.getTime();
    this.fetch();
    if (!this.$partB()) {
      this.getGroupList([this.$account().companyId]);
    }
  },
  methods: {
    fetch() {
      this.getCompanyAll();
      this.caseStatistic();
      this.manProcessingStatistic();
      this.confirmedPaymentStatistic();
      this.getSendAndResponseCount();
      this.getRecyclingchartData();
      this.batchInfoOfPandect();
      this.getNewResponseInfo();
      this.getAllResponseList();
      this.getManProcessList();
      this.urgingStatistic();
    },
    currentChange(page) {
      console.warn('选页');
      this.batchOverview.page = page;
      this.batchInfoOfPandect();
    },
    // 显示条数
    sizeChange(num) {
      console.warn('每页条数');
      this.batchOverview.limit = num;
      this.batchInfoOfPandect();
    },
    getTime() {
      const day = new Date();
      day.setTime(day.getTime());
      let month = null;
      if (day.getMonth() < 9) {
        month = day.getMonth() + 1;
        month = `0${month}`;
      } else {
        month = day.getMonth() + 1;
      }
      let date = null;
      if (day.getDate() < 10) {
        date = `0${day.getDate()}`;
      } else {
        date = day.getDate();
      }
      const s1 = `${day.getFullYear()}-${month}-${date} 00:00:00`;
      console.warn(s1);
      this.searchQuery.importStartTime = s1;
    },
    // 搜索
    search() {
      this.fetch();
    },
    // 重置
    resetBtn() {
      this.searchQuery.companyName = [];
      this.searchQuery.batchNo = [];
      this.searchQuery.importStartTime = '';
      this.searchQuery.importEndTime = '';
      this.reload();
    },
    // 公司下拉框
    getCompanyAll() {
      this.$ajax({
        url: '/overview/getCompanyList',
        method: 'get'
      }).then((res) => {
        this.companyNameList = res.data;
      }).catch((error) => {
        this.$message({
          type: 'error',
          message: error.message
        });
      });
    },

    // 案件总数统计
    caseStatistic() {
      const query = this.getParamer();
      this.$ajax({
        // prompt: true,
        url: '/overview/caseStatistic',
        params: query
      }).then((res) => {
        this.total = res.data.sum; // 案件总数
        this.perDay = res.data.increment;// 案件日同比
        this.daily = res.data.perMonth; // 日均案件量
      });
    },
    // 作业中案件统计
    urgingStatistic() {
      const query = this.getParamer();
      this.$ajax({
        // prompt: true,
        url: '/overview/urgingStatistic',
        params: query
      }).then((res) => {
        this.colling = res.data.sum;
        this.collingMean = res.data.perCollectionDays;// 平均作业天数

        const arr = [];
        let min = 0;
        let max = 0;
        for (let index = 0; index < res.data.urgingData.length; index++) {
          const element = res.data.urgingData[index];
          const entity = {
            日期: element.collectionDates,
            作业案件数: element.collectionCount
          };
          arr.push(entity);
          min = min > element.collectionCount ? element.collectionCount : min;
          max = max < element.collectionCount ? element.collectionCount : max;
        }
        if (min > 5000) {
          this.chartOpts1.yAxis.max = max + 10000;
          this.chartOpts1.yAxis.min = min - 5000;
        } else {
          this.chartOpts1.yAxis.max = max + 1000;
          this.chartOpts1.yAxis.min = min;
        }
        this.headerChartData1.rows = arr;
      });
    },
    // 待人工处理案件统计
    manProcessingStatistic() {
      const query = this.getParamer();
      this.$ajax({
        // prompt: true,
        url: '/overview/manProcessing',
        params: query
      }).then((res) => {
        this.manProcessing = res.data.sum; // 待人工处理案件数
        this.manProcessingMean = res.data.perManProcess;// 日均待人工处理案件数
        const arr = [];
        let min = 0;
        let max = 0;
        for (let index = 0; index < res.data.list.length; index++) {
          const element = res.data.list[index];

          const entity = {
            日期: element.manProcessingDate,
            待人工处理案件数: element.manProcessingCount
          };
          arr.push(entity);
          min = min > element.manProcessingCount ? element.manProcessingCount : min;
          max = max < element.manProcessingCount ? element.manProcessingCount : max;
        }
        if (min > 500) {
          this.chartOpts2.yAxis.max = max + 500;
          this.chartOpts2.yAxis.min = min - 100;
        } else {
          this.chartOpts2.yAxis.max = max + 100;
          this.chartOpts2.yAxis.min = min - 10;
        }
        this.headerChartData2.rows = arr;
      });
    },
    // 已还款案件统计
    confirmedPaymentStatistic() {
      const query = this.getParamer();
      this.$ajax({
        // prompt: true,
        url: '/overview/confirmedPayment',
        params: query
      }).then((res) => {
        this.confirmedPayment = res.data.confirmedPayment; // 已还款案件数
        this.scale = res.data.percent;// 核实还款占总作业中案件比例
      });
    },
    getParamer() {
      const params = {};
      if (this.searchQuery.importStartTime) {
        params.importStartTime = this.searchQuery.importStartTime;
      }
      if (this.searchQuery.importEndTime) {
        params.importEndTime = this.searchQuery.importEndTime;
      }
      if (this.searchQuery.batchNo.join(',')) {
        params.batchNo = this.searchQuery.batchNo.join(',');
      }
      if (this.searchQuery.companyName.join(',')) {
        params.companyId = this.searchQuery.companyName.join(',');
      }
      if (this.searchQuery.groupIds.join(',')) {
        params.groupIds = this.searchQuery.groupIds.join(',');
      }
      return params;
    },
    // 折线图数据
    getSendAndResponseCount() {
      const type = this.radio;
      const query = this.getParamer();
      query.selectedModel = type;
      this.$ajax({
        url: '/overview/getSendAndResponseCount',
        params: query
      }).then((res) => {
        let entity = {};
        const arr = [];
        for (let index = 0; index < res.data.length; index++) {
          const element = res.data[index];
          if (type === 'day') {
            entity.日期 = element.time;
          } else if (type === 'week') {
            entity.日期 = element.weekTime;
          } else if (type === 'month') {
            entity.日期 = element.monthTime;
          }
          entity.短信发送量 = element.smsSendCount;
          entity.语音发送量 = element.voiceSendCount;
          entity.短信回复量 = element.smsResponseCount;
          arr.push(entity);
          entity = {};
        }
        this.chartData.rows = arr;
      });
    },
    // 每日回收数据
    getRecyclingchartData() {
      const type = this.radioRecycling;
      const query = this.getParamer();
      query.selectedModel = type;
      this.$ajax({
        url: '/overview/getRecyclingchartData',
        data: query
      }).then((res) => {
        let entity = {};
        const arr = [];
        for (let index = 0; index < res.data.length; index++) {
          const element = res.data[index];
          if (type === 'day') {
            entity.日期 = element.time;
          } else if (type === 'week') {
            entity.日期 = element.weekTime;
          } else if (type === 'month') {
            entity.日期 = element.monthTime;
          }
          entity.案件导入量 = element.importCount;
          entity.回收率 = element.caseRecoveryRate;
          arr.push(entity);
          entity = {};
        }
        this.RecyclingchartData.rows = arr;
      });
    },
    // 案件状态分布数据
    // getCaseStatusBanch() {
    //   const query = this.getParamer();
    //   this.$ajax({
    //     url: '/overview/getCaseStatusBanch',
    //     params: query
    //   }).then((res) => {
    //     this.chartData1.rows = res.data;
    //   });
    // },
    // 批次总览数据
    batchInfoOfPandect() {
      this.batchInfoOfPandectLoading = true;
      const query = this.getParamer();
      const batchOverview = this.batchOverview;
      query.limit = batchOverview.limit;
      query.page = batchOverview.page;
      this.$ajax({
        url: '/overview/batchInfoOfPandect',
        data: query
      }).then((res) => {
        this.tableData = res.data.list;
        this.batchOverview.totalRecords = res.data.totalRecords;
        this.batchInfoOfPandectLoading = false;
      });
    },
    toCaseList(row) {
      this.operateCache([row.batchId], []);
      window.open('/main/case/caseList');
    },
    tobatchReport(row) {
      this.operateCache([row.batchId], []);
      sessionStorage.setItem('reportBatchId', row.batchNo);
      window.open('main/collection/report');
    },
    // 待人工处理数据
    getManProcessList() {
      this.manProcessLoading = true;
      const query = this.getParamer();
      this.$ajax({
        url: '/overview/getManProcessList',
        params: query
      }).then((res) => {
        this.manProcessTbody = res.data;
        this.manProcessLoading = false;
      });
    },
    toDetail(row) {
      window.open(`/main/case/detail/${Base64.encode(row.caseId)}`);
    },
    // 初始化最新回复信息
    getNewResponseInfo() {
      this.newResponseLoading = true;
      const query = this.getParamer();
      this.$ajax({
        url: '/overview/getNewResponseInfo',
        params: query
      }).then((res) => {
        const arr = [];
        res.data.forEach((item) => {
          arr.push({ author: item.customername, message: item.content, date: moment(item.time).format('YYYY-MM-DD'), time: moment(item.time).format('HH:mm:ss'), caseId: item.caseId });
        });
        this.messages = arr;
        this.newResponseLoading = false;
      });
    },
    operateCache(batchNo, caseStatus) {
      const caseSearchBody = {
        page: 1,
        limit: 50,
        order: 'aCaseId',
        sort: 'desc',
        batchNo,
        caseStatus
      };
      localStorage.removeItem('caseSearchCompanyId');
      localStorage.removeItem('caseSearchCache');
      sessionStorage.removeItem('dataReportType');
      localStorage.setItem('caseSearchCompanyId', this.$account().companyId);
      const caseSearchCache = JSON.stringify(caseSearchBody);
      localStorage.setItem('caseSearchCache', caseSearchCache);
      sessionStorage.setItem('dataReportType', 'batchReport');
    },
    getAllResponseList() { // 查询用户回复信息
      this.allResponseLoading = true;
      const query = this.getParamer();
      const allResponseOverview = this.allResponseOverview;
      query.limit = allResponseOverview.limit;
      query.page = allResponseOverview.page;
      this.$ajax({
        url: '/overview/queryAllResponse',
        data: query
      }).then((res) => {
        this.allResponseList = res.data.list;
        this.allResponseOverview.totalRecords = res.data.totalRecords;
        this.allResponseLoading = false;
      });
    },
    getAllResponseCurrentChange(page) {
      console.warn(page);
      this.allResponseOverview.page = page;
      this.getAllResponseList();
    },
    // 显示条数
    getAllResponseSizeChange(num) {
      console.warn(num);
      this.allResponseOverview.limit = num;
      this.getAllResponseList();
    },
    // 获取策略组列表
    getGroupList(companyIds) {
      this.groupList = [];
      this.groupIds = [];
      if (companyIds.length === 0) {
        return;
      }
      this.$ajax({
        url: '/strategy/getGroupList',
        method: 'POST',
        data: {
          companyIds
        }
      }).then((res) => {
        this.groupList = res.data;
      });
    },
    companyChange(company) {
      this.getGroupList(company);
    }
  },
  components: {
    VeLine, VeRing, VeHistogram, TimeLine, BatchSelector
  }
};
</script>
<style lang="less" scoped>
@import '../../../assets/style/variable.less';
.fixed-header {
  padding: 30px 24px 15px 24px;
  border-bottom: 1px solid #e8e8e8;
}
.index-header {
  .el-card__body {
    padding: 20px 20px 8px;
    .card-content {
      h3 {
        strong {
          font-size: 30px;
        }
      }
      .chart-content {
        margin-bottom: 12px;
        position: relative;
        height: 46px;
        .chart-content__fixed {
          position: absolute;
          left: 0;
          bottom: 0;
          width: 100%;
        }
      }
    }
    .card-footer {
      margin-top: 8px;
      padding-top: 9px;
      border-top: 1px solid #e8e8e8;
    }
    .el-icon-caret-top {
      color: #f5222d;
    }
    .el-icon-caret-bottom {
      color: #52c41a;
    }
  }
}
.index-section {
  .send-options {
    a {
      margin-left: 15px;
      text-decoration: none;
      color: rgba(0, 0, 0, .75);
      &.active {
        color: @primary;
      }
      &:hover {
        color: @primary;
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/page/main/index/index.vue